import { Button } from "@material-tailwind/react";
import React from "react";
import { useNavigate } from "react-router-dom";

function ReceiptButton({
  id,
  full = true,
  disabled = false,
  text = "Registered",
  link,
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    // navigate(`/home/conference/receipt/${id}`);
    navigate(link);
  };

  return (
    <Button
      color="blue-gray"
      fullWidth={full}
      onClick={handleClick}
      disabled={disabled || id === null}
    >
      {disabled ? text : id === null ? "Paid" : "View Receipt"}
    </Button>
  );
}

export default ReceiptButton;
